import React, { useEffect, useState } from "react";
import { listPaleos, deletePaleo } from "../api/dinosApi";
import { Link } from "react-router-dom";

const AdminPaleosList = () => {
  const [paleos, setPaleos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState(null);

  const fetchPaleos = async () => {
    try {
      setLoading(true);
      const res = await listPaleos();
      setPaleos(res.data);
    } catch (err) {
      console.error(err);
      setMsg("No se pudieron cargar los paleontólogos.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaleos();
  }, []);

  const handleDelete = async (id) => {
    const ok = window.confirm("¿Seguro querés eliminar este paleontólogo?");
    if (!ok) return;

    try {
      await deletePaleo(id);
      setMsg("Paleontólogo eliminado.");
      // recargo lista
      setPaleos((prev) => prev.filter((p) => p._id !== id));
    } catch (err) {
      console.error(err);
      setMsg(
        err?.response?.data?.message ||
          "Error al eliminar. (¿Está asociado a un dino?)"
      );
    }
  };

  return (
    <div className="container">
      <div className="d-flex align-items-center justify-content-between mb-3">
        <h2 className="m-0"> Admin: Paleontólogos</h2>

        <Link to="/admin/paleos/new" className="btn btn-success">
          + Crear Paleontólogo
        </Link>
      </div>

      {msg && <div className="alert alert-info">{msg}</div>}

      {loading ? (
        <div className="alert alert-secondary">Cargando...</div>
      ) : paleos.length === 0 ? (
        <div className="alert alert-warning">
          No hay paleontólogos cargados.
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table table-bordered align-middle">
            <thead className="table-light">
              <tr>
                <th>Nombre</th>
                <th>País</th>
                <th>Especialidad</th>
                <th style={{ width: "220px" }}>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {paleos.map((p) => (
                <tr key={p._id}>
                  <td>{p.name}</td>
                  <td>{p.country || "-"}</td>
                  <td>{p.specialty || "-"}</td>
                  <td className="d-flex gap-2">
                    <Link
                      to={`/admin/paleos/edit/${p._id}`}
                      className="btn btn-primary btn-sm"
                    >
                      Editar
                    </Link>

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => handleDelete(p._id)}
                    >
                      Eliminar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AdminPaleosList;
